import { render, staticRenderFns } from "./PageInner.vue?vue&type=template&id=600189e2&"
import script from "./PageInner.vue?vue&type=script&lang=js&"
export * from "./PageInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports